import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Smartphone, X } from "lucide-react";

const InstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!promptEvent) return;
    promptEvent.prompt();
    try {
      await promptEvent.userChoice;
    } catch {}
    setPromptEvent(null);
  };

  return (
    <AnimatePresence>
      {promptEvent && !dismissed && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-[84px] left-5 md:bottom-5 z-[60] glass gold-hairline rounded-full pl-4 pr-2 py-2 flex items-center gap-3"
          data-testid="install-prompt"
        >
          <Smartphone size={16} className="text-[#d4af37]" />
          <span className="text-xs text-zinc-300">Install the Jwellary app</span>
          <button
            onClick={install}
            className="text-[11px] tracking-wide uppercase bg-[#d4af37] text-[#0a0a0b] font-semibold px-3.5 py-1.5 rounded-full hover:bg-[#f3e5ab] transition-colors"
            data-testid="install-confirm-button"
          >
            Install
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 text-zinc-500 hover:text-zinc-300 transition-colors"
            data-testid="install-dismiss-button"
            aria-label="Dismiss install prompt"
          >
            <X size={13} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InstallPrompt;
